
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.33 94.33"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.17 0a47.17 47.17 0 1047.17 47.17A47.17 47.17 0 0047.17 0zm17.56 49.77L37.51 65.48a2.69 2.69 0 01-4-2.33V31.73a2.7 2.7 0 011.35-2.33 2.67 2.67 0 012.68 0l27.19 15.71a2.7 2.7 0 010 4.66z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/tabs/play.svg